import { inject, Injectable } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { ObjectSelectionService } from '../../outputs/annotation/annotation-shared/utils/object-selection.service';
import { RootKeyboardShortcutService } from '../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';

@Injectable()
export class EscapeKeyboardShortcutService extends InjectableSuperclass {
  private objectSelectionService = inject(ObjectSelectionService);
  private keyboardShortcutService = inject(RootKeyboardShortcutService);

  register() {
    this.subscribeTo(
      this.keyboardShortcutService.getEvent$('cancelTool'),
      () => {
        this.objectSelectionService.setSelection([]);
      },
    );
  }
}
